<template>
  <div class="mdc-dialog" data-mdc-auto-init="MDCDialog" style="display: block; z-index: 999;" tabindex="0" @click.prevent="leftBtnMethods" @keypress.prevent="leftBtnMethods">
    <div class="mdc-dialog__container" style="opacity:1; transform: scale(1);" tabindex="0" @click.stop="" @keypress.stop="">
      <div class="mdc-dialog__surface" style="max-width: 522px !important; min-width: 522px !important">
        <div class="container container--narrow mgt-50">
        <label class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea w-full customize-textfield--outlined" data-mdc-auto-init="MDCTextField">
          <span class="mdc-text-field__ripple"></span>
          <textarea id="textarea"
              v-model="message"
              aria-labelledby="my-label-id" class="mdc-text-field__input t-body6 font-rn  pdl-15  pdr-31 pdb-32 t-line-h-26 l-spacing2" cols="40" rows="8"></textarea>
          <span id="label" class="mdc-floating-label">{{$t('1933')}}</span>
          <span class="mdc-line-ripple"></span>
        </label>
          <div class="mgt-16 mgb-50">
            <div v-for="i in range(5)"
                 :key="i"
                 :class="[star_rating === i ? 'selected' : '']"
                 class="mgb-8 pdt-7 pdb-7 pdl-14 radio-wrapper b-radius4"
            >
              <div class="mdc-form-field">

                <div class="mdc-radio customize-radio">
                  <input :id="`radio-${i}-${i}`" v-model="star_rating"
                         :value="i"
                         class="mdc-radio__native-control"
                         name="radios"
                         type="radio"
                  >
                  <div class="mdc-radio__background">
                    <div class="mdc-radio__outer-circle"></div>
                    <div class="mdc-radio__inner-circle"></div>
                  </div>
                  <div class="mdc-radio__ripple"></div>
                </div>

                <label :for="`radio-${i}-${i}`">
                  <i v-for="r in i"
                     :key="r"
                     class="material-icons t-color-starmark t-headline6 mgr-8 mgt-4"
                  >star</i>
                </label>
              </div>
            </div>
          </div>

          <div class="mgb-50 pdb-50">
            <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8"  tabindex="0" @click.prevent="submitMessage" @keypress.prevent="submitMessage">
              <div class="mdc-button__ripple"></div>
              <span class="mdc-button__label t-body2 font-r">{{$t('1932')}}</span>
            </button>
            <button class="mdc-button bg-white t-color-secondaryBtnText mgr-8"  tabindex="0" @click.prevent="leftBtnMethods" @keypress.prevent="leftBtnMethods">
              <div class="mdc-button__ripple"></div>
              <span class="mdc-button__label t-body2 font-r">{{$t('3316')}}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="mdc-dialog__scrim" style="opacity: 1;"></div>
    </div>
  </div>
</template>

<script>
import {MDCDialog} from '@material/dialog';
import {MDCTextField} from "@material/textfield";
import degreeApi from "@/api/degreeApi";
import microDegreeApi from "@/api/microDegreeApi";
import microCourseApi from "@/api/microCourseApi";

export default {
  name: "ReviewPopup",

  data() {
    return {
      message: '',
      textField: null,
      star_rating: null,
      submitState: false,
      totalPages: 1,
      currentPage: 1,
      reviewData: [],
      reviewSummaryData: {},
      infiniteId: +new Date(),
      isNoData: false,
      textAreaError: '',
      titleBrand: localStorage.getItem('brandName')
    }
  },

  mounted() {
    this.pattenDialog = new MDCDialog(document.querySelector('.mdc-dialog'))
    this.pattenDialog.listen('MDCDialog:opened', () => {})
    this.pattenDialog.listen('MDCDialog:closed', () => {})
    this.textField = new MDCTextField(document.querySelector('.mdc-text-field'))
    this.textField.value = this.message
  },

  methods: {
    range() {
      return [...Array(5).keys()].map((i) => i + 1);
    },

    close() {
      this.dialog.listen('MDCDialog:closed', () => {});
      this.dialog.close();
    },

    leftBtnMethods() {
      this.$emit('closePopup');
    },

    submitMessage(){
      this.$showLoading()
      this.submitState = true;
      let params = {
        degreeId: this.$route.params.degreeId,
        content: this.message,
        score: this.star_rating
      };
      this.textAreaError = this.message;
      if(this.star_rating === null) {
        this.$hideLoading();
        this.$snackOpen({contents: this.$t('3179'), btnDisplayYN: false}).then(() => {})
      } else {
        microDegreeApi.learnPostReview(params).then((response) => {
          this.$hideLoading()
          this.leftBtnMethods();
          this.$emit('reviewKeyUpdate');
        }).catch((err) => {this.$hideLoading() });
        this.$hideLoading();
      }
    },

    fetchData($state) {
      let params = this.setParams();
      microDegreeApi.guestLearnOnlineViewReviewSummary(params).then((response) => {
        this.reviewSummaryData = response.data.data;
      }).catch((err) => {});
    },

    setParams() {
      const params = {
        degreeId: this.$route.params.degreeId,
        page: this.currentPage,
      };
      return params;
    },
  }
}
</script>

<style scoped>

</style>
